export default "__VITE_PUBLIC_ASSET__d001b866__"